// @flow
import React, { type Element } from 'react';
import { pure } from 'recompose';
import { stylesColors, stylesTypography } from 'angieslist-styles';
import ReactTruncate from 'react-truncate';
import type { Coupon } from '../../types';

const { backgroundGray } = stylesColors;
const { bold, semibold } = stylesTypography;
const styles = {
  carouselItemBg: {
    background: backgroundGray,
    minHeight: '100%',
    maxHeight: '100%',
    padding: '20px 10px',
    position: 'relative',
  },
  iconScissors: {
    position: 'absolute',
    display: 'block',
    top: '50%',
    width: '100%',
    height: 120,
    marginTop: -60,
    color: 'white',
    fontSize: 120,
    textAlign: 'center',
    zIndex: 1,
  },
  carouselContent: {
    position: 'relative',
    zIndex: 10,
  },
  carouselItemHead: {
    marginTop: 12,
    fontSize: 20,
    fontWeight: bold,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  carouselItemText: {
    fontWeight: semibold,
    fontSize: 16,
  },
  carouselItemLink: {
    fontSize: 13,
    fontWeight: semibold,
    textTransform: 'uppercase',
  },
};

export const CouponCarouselItemComponent = ({
  couponText,
  categoryName,
}: Coupon): Element<"div"> => (
  <div style={styles.carouselItemBg} className="carousel-item-bg">
    <i
      style={styles.iconScissors}
      className="icon icon-scissors icon-scissors-single hidden-md hidden-lg"
    />
    <i
      style={styles.iconScissors}
      className="icon icon-scissors icon-scissors-double hidden-xs hidden-sm"
    />
    <i
      style={styles.iconScissors}
      className="icon icon-scissors icon-scissors-double hidden-xs hidden-sm"
    />
    <div style={styles.carouselContent}>
      <h4 style={styles.carouselItemHead}>
        {categoryName}
      </h4>
      <p style={styles.carouselItemText}>
        <ReactTruncate lines={2}>
          {couponText}
        </ReactTruncate>
      </p>
    </div>
  </div>
);

export default (pure(CouponCarouselItemComponent): any);



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/CouponCarouselItem.js